<template>
  <div>
    <section class="section">
      <!-- 3/12カラム構成 -->
      <div class="field">
        <div class="control">
          <div id="map"></div>
        </div>
      </div>
      <input class="button is-primary is-fullwidth" type="button" value="決定" @click="submit">
      <div>
      </div>
    </section>
  </div>
</template>

<script>
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import { mapState, mapGetters } from 'vuex'
const T_STD = new L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
  attribution: "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>"
})
const T_PALE = new L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png', {
    attribution: "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>"
})
const O_STD = new L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
})
const BASEGIS = new L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg', {
    attribution: "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>"
})

export default {
    data: function() {
        return {
          showModal: false,
          map: null,
          location: null,
          layer: L.featureGroup(),
          isNotification: false,
          hasMessage: false,
          message: '',
          isError: false,
          Map_BaseLayer: {
            "地理院地図 標準": T_STD,
            "地理院地図 淡色": T_PALE,
            "地理院地図 航空写真": BASEGIS,
            "OpenStreetMap 標準": O_STD
          },
        }
    },
    computed:{
      ...mapGetters({
        user: 'auth/user'
      }),
      ...mapState({
        apiStatus: state => state.item.apiStatus
      })
    },
    mounted() {
      this.initMap()
      this.markerCreate()
    },
    methods: {
      initMap () {
        this.location = L.latLng(this.user.location.lat, this.user.location.lng)
        this.map = L.map( 'map', { center: this.location, zoom: 15 }).addLayer( L.tileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' ))
        L.control.layers(this.Map_BaseLayer, null, {
          collapsed: true
        }).addTo(this.map)
        this.map.on('click', e => {
          this.location = e.latlng
          this.markerCreate()
        });
      },
      markerCreate () {
        this.layer.clearLayers()
        let marker = L.marker(this.location, {
          icon: L.icon({
            iconUrl: 'static/mitsuketa_yellow.svg',
            iconSize: [48, 48],
          }),
          draggable: true,
        });
        //ドラックイベント設定
        var _this = this; //thisを参照できないので事前に変数へ代入
        marker.on('dragend', e => {
          _this.location = e.target._latlng
        })
        this.layer.addLayer(marker)
        this.map.addLayer(this.layer)
      },
      async submit () {
        await this.$store.dispatch('item/setLocation', {'id': this.user.id, 'lat': this.location.lat, 'lng': this.location.lng })
        if(this.apiStatus){
          this.$swal({
            position: 'top-end',
            icon: 'success',
            title: 'マップの初期値を設定しました。',
            showConfirmButton: false,
            timer: 2000
          })
        }
      },
    }
};
</script>

<style scoped>

#map {
  width: 100%;
  height: calc(100vh - 210px);
}

</style>
